module.exports = __webpack_public_path__ + "29d443e14b87d29af9ec5895680d6813.pdf";